export default {
    name: "sendBillInvalidManage",
	created: function () {
		this.init();
	},
    data() {
        return {
            searchForm: {
                sendCompany: null,
				printApplyState: null,
                postagedState: null,
				signForState:null,
				applyTime:null,
				auditTime:null,
				postagedTime:null,
				signForTime:null,
                page: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
			let conditionParam = this.$routerUtil.getParam();
			if(conditionParam && conditionParam.searchForm){
				conditionParam = conditionParam.searchForm;
			}
			if(conditionParam){
				this.$routerUtil.clearParam();
				this.$nextTick(() => {
					this.searchForm = conditionParam;
					this.doSearch();
				});
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
			this.$nextTick(()=>{
                    this.$refs.searchForm.resetFields();
            })    
		},
        doSearch() {
			var that= this;
			const condition = new Object();
			condition.pageIndex = that.searchForm.page;
			condition.pageSize = that.searchForm.pageSize;
			condition.sendCompanyName= that.searchForm.sendCompany;
			//condition.printStatus = that.searchForm.postagedState;
			
			// if(that.searchForm.recAuditState){
			// 	condition[that.searchForm.recAuditState.key] = that.searchForm.recAuditState.value;
			// }
			//condition.scAuditStatus = that.searchForm.sendAuditState
			// if(that.searchForm.applyTime){
			// 	condition.applyDayBeginTime = that.searchForm.applyTime[0];
			// 	condition.createTimeEndTime = that.searchForm.applyTime[1];
			// }
			// if(that.searchForm.auditTime){
			// 	condition.platformAuditDayBeginTime = that.searchForm.auditTime[0];
			// 	condition.platformAuditDayEndTime = that.searchForm.auditTime[1];
			// }
			// if(that.searchForm.recFristAuditTime){
			// 	condition.rcfAuditUserDayBeginTime = that.searchForm.recFristAuditTime[0];
			// 	condition.rcfAuditUserDayEndTime = that.searchForm.recFristAuditTime[1];
			// }
			// if(that.searchForm.recFinalAuditTime){
			// 	condition.rcsAuditUserDayBeginTime = that.searchForm.recFinalAuditTime[0];
			// 	condition.rcsAuditUserDayEndTime = that.searchForm.recFinalAuditTime[1];
			// }
			const param = this.$paramUtil.clearEmpty(condition);
			console.log(param);
			
			this.$axios({
				method: "get",
				url: "api/billOfLadings/voidBillOfLadingManage", // 接口地址
				params:param
				}).then(res => {
					this.tableData = res.data.resultData.rows;
					this.total = res.data.resultData.total;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: 'This is an error message',
						type: 'error',
						center: true
					});
				}); // 失败的返回
        },
		doInvallid(){
			const row = this.getSelectedRow();
			if (row) {
				if(row.hasAllInvalid){
					this.$message({
						message: this.$t('c_billInvalidManage.message_hasAllApply'),
						type: 'warning',
						center: true
					});
					return;
				}
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
				conditionData.row = row;
				this.$router.push('BillInvalid');
				this.$routerUtil.setParam(conditionData);
			}
		},
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
					center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
					center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
